import { render, staticRenderFns } from "./TransactionPaid.vue?vue&type=template&id=6dbf524e"
import script from "./TransactionPaid.vue?vue&type=script&lang=js"
export * from "./TransactionPaid.vue?vue&type=script&lang=js"
import style0 from "./TransactionPaid.vue?vue&type=style&index=0&id=6dbf524e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports